import React from "react";

import { PostVendor } from "api/rpc/2024-04/facilityAdmin/product/vendor";
import VendorForm from "pages/secure/vendors/VendorForm";
import { VendorWrite } from "pages/secure/vendors/vendorFormState";

export default function VendorsNew() {
  return (
    <VendorForm
      mode="new"
      listPath="/admin/settings/vendors"
      editPath={id => "/admin/settings/vendors/" + String(id)}
      save={(payload: VendorWrite) => PostVendor(payload, true)}
    />
  );
}
